import React, { PropTypes } from 'react';

import './styles.scss';

const PureCheckbox = props => (
  <div
    className={`checkbox ${props.className}`}
    value={props.value}
    onClick={() => props.onClick && props.onClick()}
  >
    <div className={`check ${props.value}`}>
      {
        props.value ?
          <i className='fa fa-check' aria-hidden='true' /> : null
      }
    </div>
    {
      props.name ? <label>{props.name}</label> : ''
    }
  </div>
);

PureCheckbox.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.bool,
};

export default PureCheckbox;



// WEBPACK FOOTER //
// ./src/components/shared/pureCheckbox/index.jsx